import React from "react";

export function ProfileCompleteThankYou({ onGoToDashboard, onViewProfile }) {
  return (
    <div className="step-content-card profile-complete-thank-you">
      <div className="profile-complete-thank-you-icon" aria-hidden="true">✓</div>
      <h2 className="profile-complete-thank-you-title">Thank you</h2>
      <p className="profile-complete-thank-you-subtitle">Profile in progress</p>
      <p className="profile-complete-thank-you-message">
        After approval, you&apos;ll be able to access the weddingzvenue application.
      </p>
      <div className="profile-complete-thank-you-actions">
 
      
      </div>
    </div>
  );
}
